import React from 'react';
import { useTheme, defaultTheme, useFlowPortalContent } from '../../context/PortalThemeContext';
import { fallbackString } from '../shared/FallbackUtils';

interface ReturnPolicyLinkProps {
    addShadow?: boolean;
    flowType?: 'RETURN' | 'CLAIM';
}

const ReturnPolicyLink = ({ addShadow = false, flowType = 'RETURN' }: ReturnPolicyLinkProps) => {
    const theme = useTheme();
    const flowPortalContent = useFlowPortalContent(flowType);
    
    // Safety check - don't render until we have the required data
    if (!theme || !flowPortalContent) {
        return null; // Don't render anything until theme is loaded
    }
    
    // Debug logging
    // console.log('ReturnPolicyLink: theme loaded:', theme);
    // console.log('ReturnPolicyLink: flowPortalContent loaded:', flowPortalContent);
    // console.log('ReturnPolicyLink: flowType:', flowType);
    
    // Get the return policy URL with proper fallbacks
    const returnPolicyUrl = theme?.flowPortalContentSettings?.[flowType]?.orderLookup?.returnPolicyUrl || 
                           defaultTheme?.flowPortalContentSettings?.[flowType]?.orderLookup?.returnPolicyUrl || 
                           `https://${theme?.store || 'yourstore.com'}`;
    
    // Get the return policy text with proper fallbacks
    const returnPolicyText = flowPortalContent?.orderLookup?.returnPolicyText || 
                            defaultTheme?.flowPortalContentSettings?.[flowType]?.orderLookup?.returnPolicyText || 
                            'Returns & Exchanges Policy'; // Final fallback text
    
    const shadowStyle = addShadow
        ? {
            color: 'white',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
        }
        : {};

    return (
        <a
            className="return-policy"
            style={shadowStyle}
            href={returnPolicyUrl}
            target="_blank"
            rel="noreferrer"
            onMouseEnter={e => ((e.target as HTMLAnchorElement).style.color = theme.accentColor)}
            onMouseLeave={e => ((e.target as HTMLAnchorElement).style.color = theme.textDark)}
        >
            {returnPolicyText}
        </a>
    )
}

export default ReturnPolicyLink;